import { render } from "./OhmschesGesetz.vue?vue&type=template&id=76dc211a"
import script from "./OhmschesGesetz.vue?vue&type=script&lang=js"
export * from "./OhmschesGesetz.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__